import React from 'react';

export function ToriLogo(props: React.SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            width="64"
            height="31"
            viewBox="0 0 64 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <title>Tori.fi</title>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.9995 3.73685C63.9782 5.77281 62.3051 7.40873 60.2566 7.39666C58.208 7.38458 56.5545 5.72907 56.5575 3.69299C56.5605 1.65692 58.2189 0.00622056 60.2675 0.000108566C61.2644 -0.00749572 62.2224 0.384651 62.9247 1.08789C63.6271 1.79113 64.0145 2.74608 63.9995 3.73685ZM28.789 10.0024C22.5633 10.0024 17.9717 14.4901 17.9717 20.5011C17.9717 26.5122 22.5633 30.9999 28.789 30.9999C35.0353 30.9999 39.6476 26.5122 39.6476 20.5011C39.6476 14.4901 35.0353 10.0024 28.789 10.0024V10.0024ZM28.7892 15.0048C31.8296 15.0048 34.1254 17.2692 34.1254 20.5012C34.1254 23.7332 31.8296 25.9975 28.7892 25.9975C25.7487 25.9975 23.4736 23.7331 23.4736 20.5012C23.4736 17.2692 25.7488 15.0048 28.7892 15.0048V15.0048ZM52.4672 10.0021C50.0059 10.0021 48.0824 10.8462 46.8208 12.7194V10.5374H41.5879V30.485H46.9862V19.6157C46.9862 16.6514 49.3135 15.3133 52.091 15.3133C54.4125 15.3133 55.2801 15.7662 55.2801 15.7662V10.5374C54.3882 10.1729 53.4315 9.9909 52.4672 10.0021V10.0021ZM62.9974 10.5376H57.5991V30.4853H62.9974V10.5376ZM16.5259 10.5376H9.26606V5.16473H3.86775V10.5376H0V15.3135H3.86775V23.0332C3.86775 28.2002 6.41177 30.9999 11.3757 30.9999C13.8071 31.0129 16.1781 30.2475 18.1376 28.8169L15.8732 24.7938C14.777 25.4526 13.5475 25.9975 12.2651 25.9975C10.5898 25.9975 9.26607 25.0917 9.26607 22.6009V15.3135H16.5259L16.5259 10.5376Z"
                fill="#F94F55"
            />
        </svg>
    );
}
